import React, { useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { AuthContext } from '../../contexts/AuthContext';

const GoogleCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useContext(AuthContext);

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(location.search);
      const token = params.get('token');
      const userDataStr = params.get('user');
      const error = params.get('error');

      if (error) {
        console.error('OAuth error:', error);
        navigate('/login?error=' + encodeURIComponent(error));
        return;
      }

      if (!token || !userDataStr) {
        console.error('Missing token or user data');
        navigate('/login?error=Invalid authentication response');
        return;
      }

      try {
        const userData = JSON.parse(decodeURIComponent(userDataStr));
        await login(token, userData);
        navigate('/chat');
      } catch (err) {
        console.error('Error processing callback:', err);
        navigate('/login?error=Failed to process authentication');
      }
    };

    handleCallback();
  }, [location, login, navigate]);

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant="h6" color="textSecondary">
        Completing authentication...
      </Typography>
    </Box>
  );
};

export default GoogleCallback; 